// Error normalizado para todo error que sale de las llamadas HTTP del cliente.
// Permite a los callers diferenciar errores de red, de autenticacion (401/403)
// o de servidor sin tener que conocer detalles de axios.

export type ApiErrorKind =
  | "network"
  | "unauthorized"
  | "forbidden"
  | "notFound"
  | "validation"
  | "server"
  | "unknown"

export class ApiError extends Error {
  readonly kind: ApiErrorKind
  readonly status?: number
  readonly data?: unknown

  constructor(
    message: string,
    kind: ApiErrorKind,
    status?: number,
    data?: unknown,
  ) {
    super(message)
    this.name = "ApiError"
    this.kind = kind
    this.status = status
    this.data = data
  }
}

export const isApiError = (error: unknown): error is ApiError =>
  error instanceof ApiError

export const kindFromStatus = (status?: number): ApiErrorKind => {
  if (status === undefined) return "network"
  if (status === 401) return "unauthorized"
  if (status === 403) return "forbidden"
  if (status === 404) return "notFound"
  if (status === 422 || status === 400) return "validation"
  if (status >= 500) return "server"
  return "unknown"
}
